import { render, staticRenderFns } from "./ComicsDetailView.vue?vue&type=template&id=b7f5aca6&scoped=true&"
import script from "./ComicsDetailView.vue?vue&type=script&lang=js&"
export * from "./ComicsDetailView.vue?vue&type=script&lang=js&"
import style0 from "./ComicsDetailView.vue?vue&type=style&index=0&id=b7f5aca6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f5aca6",
  null
  
)

export default component.exports